import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

export const getCounterparties = async (searchString = undefined) => {
  const data = await request.get(
    `/RentPlace/counterparty`,
    {
      searchString,
    },
    'При загрузке контрагентов произошла ошибка',
    []
  );
  return data.sort((a, b) => a.orderNum - b.orderNum);
};

const useCounterparties = (searchString) =>
  useQuery([queries.counterparties, searchString], () =>
    getCounterparties(searchString)
  );

export default useCounterparties;
